export default __webpack_public_path__ + "static/media/shopping-image.c7c02164.webp";